import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as CloseIcon } from '../icons/close-icon.svg';
import { ReactComponent as EventIcon } from '../icons/event-icon.svg';
import { ReactComponent as VenueDocumentIcon } from '../icons/venue-document-icon.svg';
import { ReactComponent as ContactIcon } from '../icons/contact-icon.svg';
import HeaderLogo from './HeaderLogo';
import MobileAuth from './MobileAuth';
import { VENUE_LISTING_URL, ROUTES, MOBILE_MENU_SECTIONS } from './constants';

const MobileMenu = ({
  isOpen,
  menuRef,
  isLandingPage,
  showSearchBar,
  currentUser,
  onLogout,
  isLoggingOut,
  onLoginClick,
  onCloseMenu,
  onListVenueClick
}) => {
  const handleListVenueClick = () => {
    if (onListVenueClick) {
      onListVenueClick();
    } else {
      window.open(VENUE_LISTING_URL, '_blank');
    }
    onCloseMenu();
  };

  return (
    <div className={`mobile-menu ${isOpen ? 'open' : ''}`} ref={menuRef}>
      <div className="mobile-menu-header">
        <HeaderLogo isLandingPage={isLandingPage} onClick={onCloseMenu} />

        {showSearchBar && (
          <div className="mobile-search-container">
            <form
              onSubmit={(e) => e.preventDefault()}
              className="mobile-search-form"
            >
              {/* Mobile search functionality can be added here if needed */}
            </form>
          </div>
        )}

        <button
          className="mobile-close-btn"
          onClick={onCloseMenu}
          aria-label="Close mobile menu"
        >
          <CloseIcon />
        </button>
      </div>

      <div className="mobile-menu-content">
        <div className="mobile-menu-section">
          <h3 className="mobile-menu-title">{MOBILE_MENU_SECTIONS.PLATFORM}</h3>
          <div className="mobile-menu-links">
            <Link
              to={ROUTES.EVENTS_INFO}
              className="mobile-menu-link"
              onClick={onCloseMenu}
            >
              <div className="mobile-menu-link-icon">
                <EventIcon style={{ stroke: '#046242', fill: '#046242' }} />
              </div>
              <div>
                <div className="mobile-menu-link-title">For Event Organisers</div>
                <div className="mobile-menu-link-subtitle">
                  Booking the perfect venue made simple
                </div>
              </div>
            </Link>

            <Link
              to={ROUTES.VENUES_INFO}
              className="mobile-menu-link"
              onClick={onCloseMenu}
            >
              <div className="mobile-menu-link-icon">
                <VenueDocumentIcon />
              </div>
              <div>
                <div className="mobile-menu-link-title">For Venues</div>
                <div className="mobile-menu-link-subtitle">
                  Manage your venue and bookings
                </div>
              </div>
            </Link>
          </div>
        </div>

        <Link to={ROUTES.ABOUT} className="mobile-menu-link" onClick={onCloseMenu}>
          <span>About</span>
        </Link>

        <span
          className="mobile-menu-link"
          onClick={handleListVenueClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleListVenueClick();
            }
          }}
        >
          Find your perfect venue
        </span>

        <MobileAuth
          currentUser={currentUser}
          onLogout={onLogout}
          isLoggingOut={isLoggingOut}
          onLoginClick={onLoginClick}
          onCloseMenu={onCloseMenu}
        />

        <button className="mobile-contact-btn">
          <span>Contact Us</span>
          <ContactIcon />
        </button>
      </div>
    </div>
  );
};

export default MobileMenu;

